import { Tooltip } from '@mui/material';
import { AppPermissions } from '../../constants/Permissions';
import AuthService from '../../services/auth.service';
import { ColumnExtendedStrict } from '../../types/ColumnExtended';
import { LUCTransferType } from '../../types/luc-transfer';
import { LUCTransferReceipt } from '../../types/luc-transfer-receipt';
import { dateHeader, formatCellDate } from './timeModeCell';
import { Article } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export const makeLucTransferReceiptColumns = () => {
  const col: ColumnExtendedStrict<LUCTransferReceipt>[] = [
    {
      header: 'ID',
      accessorKey: 'id',
      enableColumnFilter: false,
      size: 50,
      enableSorting: true,
      cell: ({ row }) => {
        return (
          <>
            {AuthService.hasPermission(AppPermissions.LucTransfer.Read) ? (
              <Tooltip title='View Items' placement='right' style={{ cursor: 'pointer', textAlign: 'center' }}>
                <Link to={`/transfers/${row.original.id}`}>
                  <Article style={{ height: '0.7em' }} color='action' cursor='pointer' />
                </Link>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      header: 'Session ID',
      accessorKey: 'lucTransferId',
      enableColumnFilter: false,
      size: 190,
    },
    {
      header: 'IMEI',
      accessorKey: 'imei',
      enableColumnFilter: false,
      size: 190,
    },
    {
      header: 'Control Receipt No.',
      accessorKey: 'controlReceiptNr',
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: 'User Name',
      accessorKey: 'userName',
      enableColumnFilter: false,
      size: 190,
    },
    {
      header: 'Transfer Type',
      accessorKey: 'type',
      enableColumnFilter: false,
      size: 120,

      cell: ({ row }) => (LUCTransferType[row.original.type] ?? '-').toString(),
    },
    {
      header: dateHeader('Transfer Timestamp'),
      accessorKey: 'activityTimestamp',
      enableColumnFilter: false,
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.activityTimestamp),
    },
    {
      header: 'Transferring Party',
      accessorKey: 'transferringPartyName',
      enableColumnFilter: false,
      size: 140,
    },
    {
      header: 'Receiving Party',
      accessorKey: 'receivingPartyName',
      enableColumnFilter: false,
      size: 130,
    },
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      enableColumnFilter: true,
      size: 110,
    },
    {
      header: 'Transfer Station',
      accessorKey: 'transferringFromStationIataCode',
      enableColumnFilter: true,
      size: 130,
    },
    {
      header: 'Next Station',
      accessorKey: 'transferringToStationIataCode',
      enableColumnFilter: true,
      size: 110,
    },
    {
      header: 'Quantity',
      accessorKey: 'itemCount',
      enableColumnFilter: false,
      size: 80,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      enableColumnFilter: false,
      size: 120,
      cell: ({ row, table }) => (row.original.createdDateTime ? formatCellDate(table, row.original.createdDateTime) : '-'),
    },
  ];

  return col;
};
